import { render } from "./DeleteSearchModal.vue?vue&type=template&id=79a5799f&ts=true"
import script from "./DeleteSearchModal.vue?vue&type=script&lang=ts"
export * from "./DeleteSearchModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__